import React from 'react';
import Grid from '@uber/base-icons/grid';
const Icon = () => {
  return <Grid size={16} />;
};
export default Icon;